import React, { Component } from "react";
import Header from './Header';
import Loader from './Loader';
import Menu from './Menu';
import '../assets/css/chief-complain.css';
import {CONFIG, jsUcfirst,decryptPHI} from '../helpers/Common';
import {QUESTION} from '../services/Questions';
import NextPrev from "./NextPrev";
import { Alert } from 'react-bootstrap';

class ChiefComplain extends Component {
    
    constructor(props)
    {   
        super(props);
        this.state = {
            complainTypes:'',
            complainTypeId:'',
            numberOfDays : 1,
            month : 1,
            isLoading : true,
            selectedTab : 0,
            nextStep : 3,
            complainTypeDetails : '',
            selectedComplains : new Array(),
            title:'Select Primary Complaint',
            prev:this.props.prev,
            alertComplain:''
        };
        this.selectComplainType     = this.selectComplainType.bind(this);
        this.handleAction           = this.handleAction.bind(this);
        this.handleChange           = this.handleChange.bind(this);
        this.disableTab             = this.disableTab.bind(this);
    }
    componentDidMount()
    {
        // console.log('this.props.getSelectedComplains',this.props.getSelectedComplains);
        
        if(localStorage.getItem('data'))
        {
            this.setState({
                title     : 'Select Secondary Complaint'
            })
            this.setState({
                selectedComplains: this.props.getSelectedComplains,
                
            });
        }
        QUESTION.getChiefComplainTypes().then(res => {
            if(res.data.header.error==0)
            {   
                
                var allComplains        = res.data.body.details;
                var otherComplains      = [];
                if(this.props.complainStack.length > 0){
                    var toBeSelected = this.props.complainStack['0'];
                    allComplains.forEach(element => {
                        if (element.id == toBeSelected) {
                            // console.log('toBeSelected hh',element);
                            this.setState({
                                alertComplain: element.name,
                            });
                        }else{
                            otherComplains.push(element.id);
                        }
                    });
                    // console.log('All to be selected for me',otherComplains);
                    this.setState({
                        selectedComplains: otherComplains,
                        
                    });
                }
            }

        }).catch(err => {
            return err;
        });
        
        
    }
    componentWillMount()
    {   
        
        var QuestionsData = QUESTION.getChiefComplainTypes().then(res => {
            if(res.data.header.error==0)
            {   
                
                var complainTypes       = res.data.body.details;

                complainTypes           = new Array(Math.ceil(complainTypes.length / 5)).fill().map(_ => complainTypes.splice(0,5));
                this.setState({
                    complainTypes: complainTypes,
                    isLoading: false,
                    allComplains:res.data.body.details
                });
             
            }
        // console.log('allcompliansssss',res.data.body.details);

        }).catch(err => {
            return err;
        });

        let complainData = this.props.getComplainData;
        
        if(complainData)
        {   
             if(this.props.addAnotherComplain==false)
            {
                this.setState({
                    complainTypeId  : complainData.complain_types,
                    selectedTab     : complainData.complain_types,
                    
                })
            }
            else
            {
                this.setState({
                    prev  : 5,
                })
            }
        }

        if(this.props.isModify){
            this.setState({
                complainTypeId  : "",
                selectedTab     : "",

            });
        }

    }

    selectComplainType = (e) => {

        this.setState({
            complainTypeId  : e.target.dataset.id,
            selectedTab     : e.target.dataset.id,
            
        });
        
    }
    
    handleAction = (e) => {
        if(this.state.complainTypeId)
        {   
            let saveData            = new Array();
            let complainTypeDetails = new Array();
            let complainId          = this.state.complainTypeId;
            Object.values(this.state.complainTypes).forEach(function(row,key) 
            {   
                Object.values(row).forEach(function(row2,key2) 
                {   
                    
                    if(complainId == row2.id)
                    {
                        complainTypeDetails = row2;
                    }
                    
                })
                
            })
            saveData = ({
                complain_types:this.state.complainTypeId,
                month:this.state.month,
                number_of_days: this.state.numberOfDays,
                complainTypeDetails:complainTypeDetails
            });
            this.props.setComplainData(saveData);
            if(this.props.isModify)
            {
                if(localStorage.getItem("data"))
                {
                    //  console.log('is in modify check chief complain')
                    var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data"));
                    let data=JSON.parse(decryptedData);  
                    Object.values(data).forEach((item,key)=>{
        
                        if(parseInt(saveData.complain_types) === parseInt(item.complain_type)){
                            // console.log('at cheif compain Item setter',item.complainLocationData)
                            this.props.setComplainLocation(item.complainLocationData);
                            
                        }
        
                    });
                }
                // console.log('props->getComplainData->complain_types',this.props.getComplainData.complain_types)
            }else{
            this.props.setComplainLocation("");
            }
            this.props.handleNextPrevSteps(this.state.nextStep);
        }
        else
        {
            alert('Please select Complaint Type');
        }
    }
    handlePrevAction=(e) =>{
        this.props.handleNextPrevSteps(this.state.prev);
    }
    handleChange = (e) =>{
        if(e.target.value > 0){
            this.setState({
                [e.target.name]: e.target.value,
              });      
        }
    }

    getData = (e) =>{
        return this.state.complainTypeId
    }
    disableTab = (id) =>
    {
        let selectedComplains = this.state.selectedComplains;

        if(this.props.isModify && !this.props.addAnotherComplain){

            if(selectedComplains.indexOf(id)!=-1)
            {
                return false;
            }
            else
            {
                return true;
            }
        }else{

            if(selectedComplains.indexOf(id)!=-1)
            {
                return true;
            }
            else
            {
                return false;
            }
        }

    }
    render() {
       
        return (
            <React.Fragment>
                <Header title={this.state.title} titleImage="ic-band-aid.png" />
                <Menu />
                {(this.props.complainStack.length > 0) ? 
                <Alert   variant='primary' onClose={() => {}}>
                    <center>Please select <b>{this.state.alertComplain}</b> option for further assessment!</center>
                </Alert>
                : ''
                }
                
                <section className="chief-complain">
                    <div className="male-model-complain">
                        <div className="container">
                            <div className="male-img">
                                <img src={require('../assets/img/content-img/male-img.png')} alt="" />
                                {
                                    this.state.isLoading!=0 &&
                                    <Loader/>
                                }
                                <div className="complain-buttons">
                                    <div className="complain-buttons">
                                        {Object.values(this.state.complainTypes).map((row, key) => (
                                            <div className={key%2==0 ? 'left-btn' :'right-btn'} key={key}>
                                            {Object.values(row).map((row2, key2) => {

                                                if (this.props.isModify && !this.props.addAnotherComplain) {

                                                    return(
                                                        <a onClick={this.selectComplainType} key={key2}
                                                           href="javascript:void(0)" data-id={`${row2.id}`}
                                                           className={`btn btn-custom  ${row2.name} ${this.state.selectedTab == (row2.id) ? 'is--active' : ''} ${this.disableTab(row2.id) == true ? 'is--active is--disable' : ''}`}>{row2.name}</a>
                                                    );

                                                }else if(this.props.isModify && this.props.addAnotherComplain){

                                                    return(
                                                        <a onClick={this.selectComplainType} key={key2}
                                                           href="javascript:void(0)" data-id={`${row2.id}`}
                                                           className={`btn btn-custom  ${row2.name} ${this.state.selectedTab == (row2.id) ? 'is--active' : ''} ${this.disableTab(row2.id) == true ? 'is--active is--disable' : ''}`}>{row2.name}</a>
                                                    );

                                                }else{

                                                    return (
                                                        <a onClick={this.selectComplainType} key={key2}
                                                           href="javascript:void(0)" data-id={`${row2.id}`}
                                                           className={`btn btn-custom  ${row2.name} ${this.state.selectedTab == (row2.id) ? 'is--active' : ''} ${this.disableTab(row2.id) == true ? 'is--disable' : ''}`}>{row2.name}</a>
                                                    );
                                                }

                                            })}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="complain-time">
                        <div className="container">
                            {/* <div className="complain-detail">
                                <div className="c-content">
                                    <h2>{CONFIG.WHEN_EXPERIENCED_PROBLEM}</h2>
                                </div>
                                <div className="form-group">
                                    <input name="numberOfDays" onChange={this.handleChange} type="text" value={this.state.numberOfDays} />
                                    <select name="month" onChange={this.handleChange}>
                                    {CONFIG.MONTHS.map((val, index) =>
                                    <option key={index+1} value={index+1}>{jsUcfirst(val)}</option>
                                    )};
                                    </select>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>
                <NextPrev handleNextAction={this.handleAction} next={this.props.next} prev={this.state.prev}  handlePrevAction={this.handlePrevAction} />
            
            </React.Fragment>
        );
    }
}

export default ChiefComplain;